// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  display: list-item;
  --background: white;
}
ion-content ion-searchbar {
  width: 87%;
}
ion-content .scroll-list ion-list {
  height: 100%;
}
ion-content ion-radio {
  --color: #ddd;
  --color-checked: var(--ion-color-tertiary);
}
ion-content ion-list {
  border-top-left-radius: 6px;
}
ion-content ion-list ion-item {
  cursor: pointer;
  height: auto;
}
ion-content ion-list ion-item ion-icon {
  background: var(--ion-color-primary);
  border-radius: 8px;
  padding: 5px;
  color: #ffffff;
  width: 16px;
  height: 16px;
}
ion-content ion-list ion-item.item:hover a {
  background-color: #ffffff !important;
  --background: #ffffff !important;
}
ion-content .delete {
  color: --ion-color-danger !important;
}

:host {
  background: var(--ion-color-primary, #01091a);
}

ion-header ion-toolbar {
  --min-height: var(--boxx-modal-toolbar-min-height, 64px);
  --background: #f8f9fb;
  color: var(--boxx-modal-toolbar-color, var(--ion-text-color));
  border-top-left-radius: var(--boxx-modal-toolbar-topleft-radius, 10px);
  border-top-right-radius: var(--boxx-modal-toolbar-topright-radius, 10px);
  --background: #fff;
}
ion-header ion-toolbar ::ng-deep ion-title {
  margin-left: var(--boxx-modal-title-margin-left, 16px) !important;
  padding: var(--boxx-modal-title-padding, 0px);
  font-size: var(--boxx-modal-title-font-size, 17px);
}
ion-header ion-toolbar ion-buttons[slot=end] {
  margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);
}
ion-header ion-toolbar #grabber {
  width: var(--boxx-modal-grabber-width, 36px);
  height: var(--boxx-modal-grabber-height, 5px);
  background: var(--boxx-modal-grabber-background, #c7c7cc);
  margin: var(--boxx-modal-grabber-margin, 0 auto);
  position: var(--boxx-modal-grabber-position, absolute);
  top: var(--boxx-modal-grabber-top, 7px);
  left: var(--boxx-modal-grabber-left, 15px);
  right: var(--boxx-modal-grabber-right, 0);
}
ion-header ion-toolbar ion-searchbar {
  margin: 0px;
  width: 90%;
  margin-left: 5%;
}
ion-header .mt-toolbar {
  margin-top: 45px;
  --background: #f8f9fb;
}

@media (min-width: 600px) {
  #pwaPopover {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/shared-components/lib/custom-country-picker/custom-country-picker.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;AACJ;AACE;EAEE,UAAA;AAAJ;AAQI;EACE,YAAA;AANN;AAUE;EACE,aAAA;EACA,0CAAA;AARJ;AAWE;EACE,2BAAA;AATJ;AAWI;EACE,eAAA;EACA,YAAA;AATN;AAWM;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AATR;AAaI;EACE,oCAAA;EACA,gCAAA;AAXN;AAeE;EACE,oCAAA;AAbJ;;AAkBA;EACE,6CAAA;AAfF;;AAkBE;EACE,wDAAA;EACA,qBAAA;EACA,6DAAA;EAEA,sEAAA;EACA,wEAAA;EAwBA,kBAAA;AAvCJ;AAiBI;EACE,iEAAA;EACA,6CAAA;EACA,kDAAA;AAfN;AAmBI;EACE,6DAAA;AAjBN;AAoBI;EACE,4CAAA;EACA,6CAAA;EACA,yDAAA;EACA,gDAAA;EACA,sDAAA;EACA,uCAAA;EACA,0CAAA;EACA,yCAAA;AAlBN;AAuBI;EACE,WAAA;EACA,UAAA;EACA,eAAA;AArBN;AA4BE;EACE,gBAAA;EACA,qBAAA;AA1BJ;;AA8BA;EACE;IACE,aAAA;EA3BF;AACF","sourcesContent":["ion-content {\n    display: list-item;\n    --background: white;\n\n  ion-searchbar {\n    //width: 88%;\n    width: 87%;\n  }\n\n  .scroll-list{\n    // height: 150px;\n    // --offset-bottom: auto !important;\n    // overflow: auto;\n\n    ion-list{\n      height: 100%;\n    }\n  }\n\n  ion-radio {\n    --color: #ddd;\n    --color-checked: var(--ion-color-tertiary);\n  }\n\n  ion-list {\n    border-top-left-radius: 6px;\n\n    ion-item {\n      cursor: pointer;\n      height: auto;\n\n      ion-icon {\n        background: var(--ion-color-primary);\n        border-radius: 8px;\n        padding: 5px;\n        color: #ffffff;\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    ion-item.item:hover a {\n      background-color: #ffffff !important;\n      --background: #ffffff !important;\n    }\n  }\n\n  .delete {\n    color: (--ion-color-danger) !important;\n  }\n\n}\n\n:host {\n  background: var(--ion-color-primary, #01091a);\n}\nion-header {\n  ion-toolbar {\n    --min-height: var(--boxx-modal-toolbar-min-height, 64px);\n    --background: #f8f9fb;\n    color: var(--boxx-modal-toolbar-color, var(--ion-text-color));\n\n    border-top-left-radius: var(--boxx-modal-toolbar-topleft-radius, 10px);\n    border-top-right-radius: var(--boxx-modal-toolbar-topright-radius, 10px);\n\n    ::ng-deep ion-title {\n      margin-left: var(--boxx-modal-title-margin-left, 16px) !important;\n      padding: var(--boxx-modal-title-padding, 0px);\n      font-size: var(--boxx-modal-title-font-size, 17px);\n      //font-weight: var(--boxx-modal-title-font-weight, 700);\n    }\n\n    ion-buttons[slot=\"end\"] {\n      margin-right: var(--boxx-modal-buttons-end-margin-right, 4px);\n    }\n\n    #grabber {\n      width: var(--boxx-modal-grabber-width, 36px);\n      height: var(--boxx-modal-grabber-height, 5px);\n      background: var(--boxx-modal-grabber-background, #c7c7cc);\n      margin: var(--boxx-modal-grabber-margin, 0 auto);\n      position: var(--boxx-modal-grabber-position, absolute);\n      top: var(--boxx-modal-grabber-top, 7px);\n      left: var(--boxx-modal-grabber-left, 15px);\n      right: var(--boxx-modal-grabber-right, 0);\n    }\n\n    --background: #fff;\n\n    ion-searchbar{\n      margin: 0px;\n      width: 90%;\n      margin-left: 5%;\n    }\n\n    ion-title{\n      //color: var(--ion-color-primary);\n    }\n  }\n  .mt-toolbar{\n    margin-top: 45px;\n    --background: #f8f9fb;\n  }\n}\n\n@media (min-width: 600px) {\n  #pwaPopover{\n    display: none;\n  }\n\n  ion-list {\n    ion-item {\n      //height: 45px !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
